import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Providers } from './app/providers';
import { App } from './App';
import './app/globals.css';
import { initializeTrustedTypes } from './security/trusted-types';
import { createComponentLogger, type ComponentLogger } from './lib/logging/frontend-logger';

type FrontendSpaBuildConfig = {
    projectBuildProfile: string | null;
    nodeEnv: string | null;
    minify: string | null;
    obfuscate: string | null;
    viteBuildMode: string | null;
    buildType: string | null;
    buildTag: string | null;
    buildNumber: string | null;
    releaseVersion: string | null;
    branchName: string | null;
    commitId: string | null;
    commitTimestamp: string | null;
    dirty: string | null;
};
declare const __PILLAR_FRONTEND_BUILD_CONFIG__: FrontendSpaBuildConfig;
const frontendBuildConfig: FrontendSpaBuildConfig = __PILLAR_FRONTEND_BUILD_CONFIG__;
const log: ComponentLogger = createComponentLogger('main');
log.info('Build configuration', { build_config: frontendBuildConfig });

// Initialize Trusted Types early, before any DOM manipulation
// This must happen before React renders to ensure Trusted Types policies are available
initializeTrustedTypes();

// Get instance name from environment variable (VITE_ prefix for Vite)
const instanceName = import.meta.env.VITE_PILLAR_INSTANCE_NAME || 'Anchorbase';

// Set document title
document.title = `${instanceName} Portal`;

const rootElement = document.getElementById('root');
if (!rootElement) {
    throw new Error('Root element not found');
}

const root = createRoot(rootElement);

root.render(
    <React.StrictMode>
        <BrowserRouter>
            <Providers>
                <App />
            </Providers>
        </BrowserRouter>
    </React.StrictMode>
);
